export default __webpack_public_path__ + "static/media/icon_guide_step_delete.da24aab4.svg";